import CardTable from "components/CardTable/CardTable";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import WidgetsIcon from "@material-ui/icons/Widgets";
import { useDispatch, useSelector } from "react-redux";
import { validateObject } from "helpers/validateObject";
import { useColumnsStationary } from "./useColumnsStationary";
import { saveInventory } from "redux/actions/inventories/inventoriesAction";
import { SaveInventoryButton } from "./SaveInventoryButton";
import { inventoryType } from "./inventoryType.enum";

export const StorageTable = ({
  title = "",
  keyInventory = "",
  edited = "",
  endpoint = "",
}) => {
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { inventory, station } = useSelector(({ inventories }) => inventories);
  const { storagesInventory } = inventory?.details;
  const hist = useHistory();
  const dispatch = useDispatch();

  const handleGo = () => {
    hist.push("/admin/control-inventarios");
  };

  const handleSave = (e) => {
    e.preventDefault();
    dispatch(
      saveInventory(inventory.id, endpoint, storagesInventory, keyInventory)
    );
  };

  useEffect(() => {
    validateObject(inventory, true) && handleGo();
  }, [inventory]);
  
  const columns = useColumnsStationary(
    station?.inventory_type === inventoryType.digital || station?.inventory_type === inventoryType.progressive,
    endpoint,
    keyInventory,
    edited
  );

  return (
    <CardTable
      hasHeader
      title={title}
      icon={<WidgetsIcon />}
      blockBtn
      columns={columns}
      data={inventory?.details?.storagesInventory}
      hasControl={Boolean(inventory[edited])}
      isLoading={isLoadingComp?.loadingInventoryType}
      controls={<SaveInventoryButton handleSave={handleSave} />}
    />
  );
};
